import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Index from "./pages/Index";
import Auth from "./pages/Auth";
import MyOneThing from "./pages/MyOneThing";
import { CopilotProvider } from "./components/copilot/CopilotProvider";
import Priorities from "./pages/Priorities";
import PriorityDetail from "./pages/PriorityDetail";
import Admin from "./pages/Admin";
import NotFound from "./pages/NotFound";
import Profile from "./pages/Profile";
import OrgChart from "./pages/OrgChart";
import MyTeam from "./pages/MyTeam";
import OKRs from "./pages/OKRs";
import Ppp from "./pages/Ppp";
import PppDetail from "./pages/PppDetail";
import People from "./pages/People";
import Accountability from "./pages/Accountability";
import { AuthProvider } from "./contexts/AuthContext";
import ProtectedRoute from "./components/ProtectedRoute";

const queryClient = new QueryClient();

const App = () => (
  <QueryClientProvider client={queryClient}>
    <AuthProvider>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <CopilotProvider>
            <Routes>
              <Route path="/" element={<Index />} />
              <Route path="/auth" element={<Auth />} />
              <Route
                path="/my-onething"
                element={
                  <ProtectedRoute>
                    <MyOneThing />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/priorities"
                element={
                  <ProtectedRoute>
                    <Priorities />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/priorities/:priorityPid"
                element={
                  <ProtectedRoute>
                    <PriorityDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/admin"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Admin />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/accountability"
                element={
                  <ProtectedRoute requiredRole="admin">
                    <Accountability />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/profile"
                element={
                  <ProtectedRoute>
                    <Profile />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/org-chart"
                element={
                  <ProtectedRoute>
                    <OrgChart />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/okrs"
                element={
                  <ProtectedRoute>
                    <OKRs />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ppp"
                element={
                  <ProtectedRoute>
                    <Ppp />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ppp/:pid"
                element={
                  <ProtectedRoute>
                    <PppDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/people"
                element={
                  <ProtectedRoute>
                    <People />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/my-team"
                element={
                  <ProtectedRoute>
                    <MyTeam />
                  </ProtectedRoute>
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </CopilotProvider>
        </BrowserRouter>
      </TooltipProvider>
    </AuthProvider>
  </QueryClientProvider>
);

export default App;
